export type NoteResponseBody = {
  authorId: string | null;
  authorName: string | null;
  datetime: string;
  note: string;
};
export type NoteRequestBody = {
  note: string;
};
